/**
 * Window flag so a hot reload, which re-executes this module, does not add
 * a second listener beside the one already attached to document.
 */
const installedKey = '__bizkeyDisableNumberInputWheel';

type WindowWithInstallFlag = Window & {
    [installedKey]?: boolean;
};

/**
 * Stops a focused number input from changing its value on wheel.
 *
 * The listener runs in the capture phase, before the browser's spin action.
 * Blurring the input makes that action a no-op and leaves scrolling to the
 * nearest scrollable ancestor. Unfocused number inputs are left alone.
 */
export function installDisableNumberInputWheel(): void {
    if (typeof document === 'undefined') {
        return;
    }
    const host = window as WindowWithInstallFlag;
    if (host[installedKey]) {
        return;
    }
    host[installedKey] = true;

    document.addEventListener('wheel', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || target.type !== 'number') {
            return;
        }
        if (document.activeElement !== target) {
            return;
        }
        target.blur();
    }, {capture: true, passive: true});
}
